import { CommonModule } from '@angular/common'
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core'
import { DdcLogoComponent } from '../ddc-logo/ddc-logo.component'

export interface LoadingStep {
  label: string
  completed: boolean
}

@Component({
  selector: 'ddc-splash-screen',
  templateUrl: './ddc-splash-screen.component.html',
  styleUrls: ['./ddc-splash-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, DdcLogoComponent],
})
export class DdcSplashScreenComponent implements OnInit, OnDestroy {
  @Output() splashComplete = new EventEmitter<void>()

  _steps: LoadingStep[] = [
    { label: 'Authenticating', completed: false },
    { label: 'Loading Profile', completed: false },
    { label: 'Loading Library', completed: false },
    { label: 'Preparing Lingo AI', completed: false },
  ]

  _fadeOut = false
  private timeouts: any[] = []

  ngOnInit(): void {
    this.animateSteps()
  }

  ngOnDestroy(): void {
    this.timeouts.forEach(t => clearTimeout(t))
  }

  private animateSteps(): void {
    const delayPerStep = 400

    this._steps.forEach((step, index) => {
      const t = setTimeout(
        () => {
          step.completed = true

          if (index === this._steps.length - 1) {
            const fadeT = setTimeout(() => {
              this._fadeOut = true
              const completeT = setTimeout(() => {
                this.splashComplete.emit()
              }, 500)
              this.timeouts.push(completeT)
            }, 300)
            this.timeouts.push(fadeT)
          }
        },
        (index + 1) * delayPerStep,
      )
      this.timeouts.push(t)
    })
  }
}
